import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthUser, UserResponse } from 'config/types'
import { RootState } from './store'

interface AuthState {
  isAuthenticated: boolean
  user: UserResponse | null
  Authorization: string | null
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  Authorization: null,
}

export const selectCurrentUser = (state: RootState) => state.auth.user

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<AuthUser>) {
      state.isAuthenticated = true
      state.user = action.payload.user
      state.Authorization = action.payload.token
      localStorage.setItem('auth', JSON.stringify(state))
    },
    setTokens(state, action: PayloadAction<{ Authorization: string }>) {
      state.Authorization = action.payload.Authorization
    },
    logout(state) {
      state.isAuthenticated = false
      state.user = null
      state.Authorization = null
      localStorage.removeItem('auth')
    },
  },
})

export const { loginSuccess, setTokens, logout } = authSlice.actions
export default authSlice.reducer
